import ProvisionalReceiptInfo from './ProvisionalReceiptInfo';

export default ProvisionalReceiptInfo;
